module.exports = __webpack_public_path__ + "合作11.png?bafa5030cfc61748242949561e24df20";


//////////////////
// WEBPACK FOOTER
// ./src/assets/合作11.png
// module id = 653
// module chunks = 0